###
  Campaigns widget
###

class INTENT.widgets.Campaigns

  @TYPE_ORIGINAL: "original"
  @TYPE_MOBILE: "mobile"
  @TYPE_NATIVE: "native"
  @TYPE_VIDEO: "video"

  @CLASS_HIDDEN: "hidden"

  @ATTR_NAME: "data-widget-campaigns"

  @ATTR_MOBILE: "#{@ATTR_NAME}-mobile"
  @ATTR_NATIVE: "#{@ATTR_NAME}-native"
  @ATTR_VIDEO: "#{@ATTR_NAME}-video"

  @ATTR_PREPARE: "#{@ATTR_NAME}-prepare-form"

  @ATTR_FORM: "#{@ATTR_NAME}-form"
  @ATTR_WELCOME: "#{@ATTR_NAME}-welcome"

  @ATTR_SPEND_ASAP: "#spend_asap"
  @ATTR_KEYWORDS: "#keywords"

  @ATTR_ADVERTISER_ID: "data-advertiser-id"
  @ATTR_CAMPAIGN_ID: "data-object-id"

  @ATTR_FIELD: "#{@ATTR_FORM}-field"
  @ATTR_FIELD_TYPE: "#{@ATTR_FIELD}-type"

  @ATTR_BTN_ORIGINAL: "#{@ATTR_NAME}-btn-original"
  @ATTR_BTN_MOBILE: "#{@ATTR_NAME}-btn-mobile"

  @ATTR_HEADER: "#{@ATTR_NAME}-header"

  @ATTR_AVAILABLE_INVENTORY_CALC: "#{@ATTR_NAME}-ai-calc"
  @ATTR_CTR_FIELD: "#{@ATTR_NAME}-target-ctr"
  @ATTR_MIN_CTR_FIELD: "#{@ATTR_NAME}-min-ctr"
  @ATTR_FIN_TYPE_FIELD: "#{@ATTR_NAME}-fin-type"

  @ATTR_GROUP_HANDLER: "#{@ATTR_NAME}-group-handler"

  @ATTR_MODAL_ESTIMATE: "#{@ATTR_NAME}-estimate-modal"
  @ATTR_MODAL_GROUP: "#{@ATTR_NAME}-group-modal"

  @ATTR_BUDGET_PACING: "name=budget_pacing"
  @ATTR_BUDGET_PACING_HINT: "data-budget-pacing-hint"

  @ATTR_DAILY_BUDGET_FIELD: "field-id-daily_budget"

  @LOADER_SPINNER: """ <i class="fa fa-circle-o-notch fa-spin green fa-3x"></i> """
  @LOADER_SPINNER_XS: """ <i class="fa fa-circle-o-notch fa-spin"></i> """

  @MODAL: "#modal_dynamic_price"

  constructor: (@el) ->
    @s = @.constructor

    @bulk_edit = if bulk_edit? then bulk_edit else false;

    @advertiserId = parseInt @el.find("[#{@s.ATTR_ADVERTISER_ID}]").attr(@s.ATTR_ADVERTISER_ID)
    @campaignId = parseInt @el.find("[#{@s.ATTR_CAMPAIGN_ID}]").attr(@s.ATTR_CAMPAIGN_ID)

    @calculatingInProcess = false

    mobile_attr = @el.attr @s.ATTR_MOBILE
    @mobile_campaign = (typeof mobile_attr != 'undefined' and mobile_attr != false)

    native_attr = @el.attr @s.ATTR_NATIVE
    @native_campaign = (typeof native_attr != 'undefined' and native_attr != false)

    video_attr = @el.attr @s.ATTR_VIDEO
    @video_campaign = (typeof video_attr != 'undefined' and video_attr != false)

    @form = @el.find "[#{@s.ATTR_FORM}]"
    @welcome = @el.find "[#{@s.ATTR_WELCOME}]"

    @btnOriginal = @el.find "[#{@s.ATTR_BTN_ORIGINAL}]"
    @btnMobile = @el.find "[#{@s.ATTR_BTN_MOBILE}]"
    @btnSubmit = $ '[name="update"].submit-button'

    @headersScope = @el.find "[#{@s.ATTR_HEADER}]"

    @modalEstimate = $ "[#{@s.ATTR_MODAL_ESTIMATE}]"
    @estimateBtn = @modalEstimate.find "[data-estimate]"
    @estimateResult = @modalEstimate.find "[data-estimate-result]"
    @estimateAction = @modalEstimate.find "[data-estimate-action]"

    @handlerGroup = @el.find "[#{@s.ATTR_GROUP_HANDLER}]"
    @modalGroup = $ "[#{@s.ATTR_MODAL_GROUP}]"
    @groupResult = @modalGroup.find "[data-result]"
    @groupAction = @modalGroup.find "[data-action]"
    @groupWarning = @modalGroup.find "[data-warning]"
    @groupNameField = @modalGroup.find "[name='name']"
    @groupCurrentLimitField = @modalGroup.find "[name='limit']"
    @groupLimitField = @modalGroup.find "[name='budget_limit']"
    @groupMatchBudget = @modalGroup.find "[name='match_budget']"
    @groupIdField = @modalGroup.find "[name='group_id']"
    @submitNewLimitBtn = @groupAction.find "[data-submit]"

    @submit_btn_name = 'update'
    @submit_btn_value = 'save'

    @dynPriceBtn = $('#dynamic_price span')

    @finTypeField = @el.find "[#{@s.ATTR_FIN_TYPE_FIELD}]"
    @predictTypeContainer = @el.find "[data-widget-campaigns-predict]"

    @dailyBudgetField = @el.find "#field-id-daily_budget"

    @canSubmit = false
    @validateEmptyTargeting = true

    @predictFinancigTypes = $.parseJSON @form.attr('data-predict-financing-types')
    @financigTypesWithDisabledTargetCTR = $.parseJSON @form.attr('data-disable-target-ctr-financing-types')

    $("input[type=submit], button[type=submit]").click (e) =>
      self = $ e.currentTarget
      @submit_btn_name = self.attr("name")
      @submit_btn_value = self.val()

    @finTypeField.on 'change', (e) =>
      self = $ e.currentTarget
      val = self.val()
      if jQuery.inArray(val, @predictFinancigTypes) != -1
        @predictTypeContainer.removeClass 'hidden'
      else
        @predictTypeContainer.addClass 'hidden'

    @dailyBudgetField.on 'change keydown paste cut', () ->
      el = $ @
      setTimeout(
        () ->
          budget_pacing_campaign = $ "#budget_pacing_campaign"
          budget_pacing_daily = $ "#budget_pacing_daily"
          unless el.val()
            budget_pacing_campaign.trigger 'click'
            budget_pacing_daily.attr 'disabled', true
            budget_pacing_daily.closest('.budget-pacing-block').addClass 'gray'
          else
            if budget_pacing_daily.attr 'disabled'
              budget_pacing_daily.attr 'disabled', false
              budget_pacing_daily.closest('.budget-pacing-block').removeClass 'gray'
        100
      )

    $('.submit-button').click (e) =>
      self = @
      @btnSubmit = $(e.target)

      if $("#spend_asap:checked").length && window.location.hash.indexOf("copied") != -1
        show_confirm(
          __("campaigns.form.spend_asap.warn")
          ->
            self.submitForm self.form
          ->
            self.btnSubmit.hideLoader('disabled')
          __('btn.save')
          __('btn.cancel')
        )
        return false

      if !@validateDailyBudget()
        show_confirm(
          "<span id=\"daily-budget-warn\">#{__('campaigns.message.daily-budget-warn')}</span>"
          ->
            self.submitForm self.form
          ->
            self.btnSubmit.hideLoader('disabled')
          __('btn.save')
          __('btn.cancel')
        )
        return false

    @form.on 'submit', (e) =>
      if @bulk_edit
        return true

      current = $ e.currentTarget
      data = {}

      unless @validateLandingPage()
        @btnSubmit.hideLoader('disabled');
        return false

#      is_campaign_on = $("#activate-campaign").bootstrapSwitch("state")
#      if not ignore_targeting and is_targeting_empty() and @validateEmptyTargeting
#        if is_campaign_on
#          INTENT.utils.Notify.error __("campaigns.turn-on.empty-targeting")
#        else
#          show_confirm __("campaigns.warning.empty-targeting"), (->
#            @validateEmptyTargeting = false
#            current.append('<input type="hidden" name="update" value="1">').submit()
#          ), (->
#          ), __("btn.save"), __("btn.cancel")
#
#        return false

      if @canSubmit == true
        return true

      current.find('[data-widget-targeting-type]').each ->
        self = $ @
        type = self.attr 'data-widget-targeting-type'
        countriesField = self.find '[data-countries]'
        switch type
          when 'targeting' then data.countries = countriesField.val()
          when 'negative_targeting' then data.negative_countries = countriesField.val()
          else null

      request = $.ajax({
        url: '/ajax/check_continent',
        type: "POST",
        dataType: "json",
        async: true,
        data: data
      })

      instance = @
      btnSubmit = @btnSubmit

      request.done (xhr) ->
        if xhr.valid == 1
          instance.canSubmit = true
          instance.submitForm current

        else
          continueSubmitAction = ->
            instance.canSubmit = true
            instance.submitForm current

          cancelSubmitAction = ->
            btnSubmit.hideLoader('disabled');

          show_confirm xhr.message, continueSubmitAction, cancelSubmitAction, __('btn.save'), __('btn.cancel')

      return false

    @handlerGroup.on 'change', (e) =>
      e.preventDefault()

      current = $ e.currentTarget
      group_id = parseInt current.val()

      if @previousBtnText
        @submitNewLimitBtn.html @previousBtnText
        @submitNewLimitBtn.removeAttr 'disabled'
        @previousBtnText = undefined

      if @advertiserId == 0
        return false
      if @campaignId == 0
        return false
      if group_id == 0
        return false

      request = @requestGroupEstimate group_id, @campaignId, @advertiserId
      request.done (xhr) =>
        if xhr.budget_diff == 0
          return false

        modal_opt = { backdrop: 'static' }

        @groupWarning.html ''
        @groupLimitField.parents('.form-group').removeClass('has-warning')

        @groupIdField.attr 'value', group_id
        @groupNameField.attr 'value', xhr.name_full
        @groupLimitField.val xhr.limit
        @groupCurrentLimitField.attr 'value', xhr.limit

        @groupMatchBudget.attr 'value', xhr.estimate

        if xhr.left_budget > 0
          @groupResult.html INTENT.templates.CrudCampaign.get_group_warning_overhead( __('campaign.group.left_budget', {
            ":budget": xhr.formatted_left_budget
          }) )
          @modalGroup.modal modal_opt
          #@groupLimitField.keyup()

        if xhr.group_overhead > 0
          @groupResult.html INTENT.templates.CrudCampaign.get_group_warning_overhead( __('campaign.group.overhead') )
          @modalGroup.modal modal_opt
          #@groupLimitField.keyup()

    @submitNewLimitBtn.on 'click', (e) =>
      @previousBtnText = @submitNewLimitBtn.html()
      @submitNewLimitBtn.html @s.LOADER_SPINNER_XS
      @submitNewLimitBtn.attr 'disabled', 'disabled'
      group_id = parseInt @groupIdField.val()
      advertiser_id = @advertiserId
      budget_limit = parseFloat @groupLimitField.val()
      request = @requestUpdateGroupLimit group_id, budget_limit, advertiser_id
      request.done (xhr) =>
        @submitNewLimitBtn.html @previousBtnText
        @submitNewLimitBtn.removeAttr 'disabled'
        @previousBtnText = undefined
        @modalGroup.modal('hide')

    @estimateBtn.on 'click', =>
      @estimateBtn.attr 'disabled', 'disabled'
      request = @requestAvailableInventory()
      @estimateResult.html @s.LOADER_SPINNER

      @estimateAction.hide()

      alert_text = ''
      if @needEstimationAlert() == true
        alert_text = __('campaign.available_inventory.small_alert')

      request.done (xhr) =>
        @estimateAction.hide()
        @estimateBtn.removeAttr 'disabled'
        report_url_message = ''
        if xhr.report_url?
          report_url_message = "<p class='text-center'><br/><a target='_blank' href='#{xhr.report_url}'>#{__('available_inventory.report_url')}</a></p>"

        if xhr.error
          @estimateResult.html INTENT.templates.CrudCampaign.get_result_container(xhr.message, alert_text)
        else
          @estimateResult.html INTENT.templates.CrudCampaign.get_result_container(
            __('campaign.available_inventory.result', {":inventory": xhr.formatted}),
            alert_text,
            report_url_message
          )

    @aiCalc = @el.find "[#{@s.ATTR_AVAILABLE_INVENTORY_CALC}]"
    @ctrField = @el.find "[#{@s.ATTR_CTR_FIELD}]"
    @minctrField = @el.find "[#{@s.ATTR_MIN_CTR_FIELD}]"

    @initFieldsScope()

    @btnOriginal.on "click", @onOriginalClick
    @btnMobile.on "click", @onMobileClick

    @aiCalc.on "click", @calcAvailableInventory

    need_preapre = @el.attr @s.ATTR_PREPARE
    if need_preapre? and @fieldType.length
      @onMobileClick()

    if @isMobileCampaign()
      @onMobileClick()
    else
      @onOriginalClick()

    @spendAsapControlInit()

    @keywordsControlInit()

    @targetCTRControlInit()

    @excludeDomainsHandlerInit();

    hotkay_ai = 'ctrl+i'
    if navigator.platform.match "Mac"
      hotkay_ai = 'meta+i'

    $(document).on 'keydown', null, hotkay_ai, @calcAvailableInventory

    @modalEstimate.on 'hidden.bs.modal', =>
      @aiCalcOnAir = false

    @dynPriceBtn.on 'click', (e) =>
      @showModal()

    $('.reload-campaigns-stats i').on 'click', () =>
      get_plot_chart()

    $('#learning_budget_select').on 'change', (e) =>
      values = $(e.target).val().split '::'
      $('#learning_budget_type').val(values[0]);
      $('#learning_budget_strategy').val(values[1]);

    $(document).on 'select2:open', =>
      $('.select2-results__option a').on 'mouseup', (e) =>
        e.stopPropagation()

    $(document).on 'init-global-scope', () =>
      init_campaigns_select2($('#creatives_type').val())
      initAppTargeting("#targeting_mobile_application");
      initAppTargeting("#negative_targeting_mobile_application");

    $(document).on 'mouseup', '.select2-option-link', () =>
      $('.select2-option-link').unbind('click').on 'click', (e) =>
        e.stopPropagation()

    @formChanged = false;
    @form.find('input, textarea, select').on 'change', () =>
      @formChanged = true;
    @form.find('.segments-tree.tf-tree, #campaign-start-date, #campaign-end-date').on 'click', () =>
      @formChanged = true;
    @actionUrl = @form.attr('action');
    tabsToRedirect = ['basic', 'targeting', 'other', 'extra', 'stats'];
    $('ul.nav-tabs li').on 'click', (e) =>
      href = $(e.currentTarget).find('a').attr('href') || null
      if href
        tabName = href.replace('#', '')
        if tabsToRedirect.indexOf(tabName) != -1 && !@bulk_edit
          e.stopPropagation()
          e.preventDefault()
          @redirectToSPA(tabName)

  redirectToSPA: (tabName) =>
    self = @
    if self.actionUrl.indexOf('?') == self.actionUrl.length - 1
      newAction = "#{self.actionUrl}tab=#{tabName}"
    else if(self.actionUrl.indexOf('?') != -1)
      newAction = "#{self.actionUrl}&tab=#{tabName}"
    else
      newAction = "#{self.actionUrl}?tab=#{tabName}"
    if self.formChanged || self.actionUrl.indexOf("/new") != -1
      confirmAction = ->
        self.form.attr('action', newAction)
        self.form.submit()
      cancelAction = ->
        return
      customAction = ->
        window.location.href = newAction.replace('/update/', '/edit/');
      custom = if self.actionUrl.indexOf("/new") != -1 then null else {name: __('tab-redirect.btn.continue-without-save'), action: customAction}
      show_confirm(__("tab-redirect.message"), confirmAction, cancelAction, __('tab-redirect.btn.continue-and-save'), __('btn.cancel'), custom);
    else
      window.location.href = newAction.replace('/update/', '/edit/');
      return

  submitForm: (form) =>
    tmpElement = $ """<input type="hidden" name="#{@submit_btn_name}" value="#{@submit_btn_name}">"""
    tmpElement.appendTo form
    form.submit()
    tmpElement.remove()

  getFormSerializedJson: =>
    @form.serializeObject()

  needEstimationAlert: =>
    if @ctrField.filter(':enabled').val() && @ctrField.val()
      return true

    if @finTypeField.val().indexOf("cpc") > -1
      return true

    return false

  requestUpdateGroupLimit: (group_id, budget_limit, advertiser_id) =>
    return $.ajax({
      url: '/ajax/update_group_limit',
      type: "POST",
      dataType: "json",
      async: true,
      data: {
        "group_id": group_id,
        "budget_limit": budget_limit,
        "advertiser_id": advertiser_id
      }
    })

  validateDailyBudget: =>
    dailyBudget = $("#field-id-daily_budget").val();
    budget = $("#field-id-budget").val();
    start = $("#campaign-start-date").val()
    end = $("#campaign-end-date").val()

    if !dailyBudget? or !budget? or !start? or !end?
      return true

    if dailyBudget is "" or budget is "" or start is "" or end is ""
      return true

    campaignId = if @campaignId == 0 then false else @campaignId
    advertiserId = if @advertiserId == 0 then false else @advertiserId

    request = $.ajax({
      url: '/ajax/check_daily_budget',
      type: "POST",
      dataType: "json",
      async: false,
      data: {
        advertiserId: advertiserId,
        id: campaignId,
        start: start,
        end: end,
        dailyBudget: dailyBudget,
        budget: budget
      }
    })

    status = false
    request.done (xhr) ->
      status =  xhr.valid

    return status

  validateLandingPage: =>
    url = $("#landing_page").val()
    url = url.trim()
    unless url.match(/(https?|ftp):\/\/(-\.)?([^\s\/?\.#]+\.?)+(\/[^\s]*)?$/g)
      show_notification __("campaigns.landing_page.regex"), true, "error", ->
        $("form:input").blur()
        $("#landing_page").focus()

      return false

    matches = undefined
    if (matches = url.match(/(?:[^\[])(\[[^\[]*?\]\])/i)) or (matches = url.match(/(?:[^\[])(\[{3,}[^\[]*?\]\])/i)) or (matches = url.match(/(\[\[[^\]]*?\](?:[^\]]|$))/i)) or (matches = url.match(/(\[\[[^\]]*?\]{3,})/i))
      show_notification __("campaigns.landing_page_macros.regex") + ": " + matches[1], true, "error", ->
        $("form:input").blur()
        $("#landing_page").focus()

      return false

    return true

  requestGroupEstimate: (group_id, campaign_id, advertiser_id) =>
    url = '/ajax/estimate_campaign_group'
    return $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      async: true,
      data: {
        "group_id": group_id,
        "campaign_id": campaign_id,
        "advertiser_id": advertiser_id
      }
    })

  requestAvailableInventory: =>
    url = '/livereports/available_inventory'
    return $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      data: JSON.stringify(@getFormSerializedJson())
    })

  calcAvailableInventory: =>
    if @aiCalcOnAir == true
      return false

    @aiCalcOnAir = true

    @estimateResult.html('')
    @modalEstimate.modal('show')
    if @needEstimationAlert() == false
      @estimateBtn.click()
      @estimateAction.hide()
    else
      @estimateAction.show()
      @estimateResult.html INTENT.templates.CrudCampaign.get_alert_container(__('campaign.available_inventory.alert'))

    return false

  isMobileCampaign: =>
    @mobile_campaign

  initFieldsScope: =>
    @fieldType = @form.find "[#{@s.ATTR_FIELD_TYPE}]"

  displayHeader: (type) =>
    @headersScope.hide()
    header = @headersScope.filter "[#{@s.ATTR_HEADER}='#{type}']"
    header.removeClass @s.CLASS_HIDDEN
    header.show()
    return @

  prepareOriginFields: =>
    $(".for-mobile").hide().addClass @s.CLASS_HIDDEN
    $(".for-non-mobile").show().removeClass @s.CLASS_HIDDEN

  prepareMobileFields: =>
    $(".for-mobile").show().removeClass @s.CLASS_HIDDEN
    $(".for-non-mobile").hide().addClass @s.CLASS_HIDDEN

  displayForm: =>
    @form.show()
    return @

  hideWelcomeBlock: =>
    @welcome.hide();
    return @

  switchWorkArea: =>
    @hideWelcomeBlock().displayForm()

  onOriginalClick: =>
    @fieldType.remove()
    if @native_campaign
      @displayHeader @s.TYPE_NATIVE
    else if @video_campaign
      @displayHeader @s.TYPE_VIDEO
    else
      @displayHeader @s.TYPE_ORIGINAL
    @prepareOriginFields()
    @switchWorkArea()

  onMobileClick: =>
    @displayHeader @s.TYPE_MOBILE
    @prepareMobileFields()
    @switchWorkArea()

  keywordsControlInit: =>
    if $(@s.ATTR_KEYWORDS).length == 0
      return;

    limit = $(@s.ATTR_KEYWORDS).data('keywords-limit')
    keywordsRemainInfo = $(@s.ATTR_KEYWORDS).parents('.form-group').find('#keywords-remain')
    keywordsRemainInfo.text(limit - parseInt($(@s.ATTR_KEYWORDS).val().split(/\r|\r\n|\n/).length))

    $(@s.ATTR_KEYWORDS).on 'keydown', (e) ->
      el = $(this)
      code = e.keyCode || e.which;
      lines = el.val().split(/\r|\r\n|\n/)
      setTimeout(
        () ->
          remain = limit - el.val().split(/\r|\r\n|\n/).length
          if keywordsRemainInfo.text() != remain
            keywordsRemainInfo.text(remain)
        100
      )
      if lines.length >= limit and code == 13
        return false
      return

  toggleCTRSwitch: (ctrSwitch, state) ->
    if ctrSwitch.length == 0
      return

    if state is 'disable'
      ctrSwitch.bootstrapSwitch 'state', off
      ctrSwitch.bootstrapSwitch 'readonly', on
    else
      ctrSwitch.bootstrapSwitch 'readonly', off

  targetCTRControlInit: =>
    ctrAlert = $('.ctr-alert')
    if (@finTypeField.length == 0 or ctrAlert.length == 0)
      return;

    ctrInput = @ctrField.first()
    ctrSwitch = @ctrField.eq 1
    minctrInput = @minctrField.first()
    minctrSwitch = @minctrField.eq 1

    @finTypeField.on 'change', (e) =>
      self = $ e.currentTarget
      val = self.val()
      if $.inArray(val, @financigTypesWithDisabledTargetCTR) != -1
        alertText = __('financing.messages.type.conflict', {":type": self.find('option:selected').text()})
        ctrAlert.text(alertText).css('color', '#962020')

        showAlert = false
        if ctrInput.length != 0
          if !ctrInput.attr 'disabled'
            showAlert = true
          else ctrInput.attr 'disabled', on
          @toggleCTRSwitch ctrSwitch, 'disable'

        if minctrInput.length != 0
          if !minctrInput.attr 'disabled'
            showAlert = true
          else
            minctrInput.attr 'disabled', on
          @toggleCTRSwitch minctrSwitch, 'disable'

        if showAlert
          INTENT.utils.Notify.danger alertText, {auto_hide: yes}
      else
        ctrAlert.text ''
        @toggleCTRSwitch ctrSwitch, 'enable'
        @toggleCTRSwitch minctrSwitch, 'enable'

  spendAsapControlInit: =>
    checkbox = $(@s.ATTR_SPEND_ASAP)
    parent = checkbox.closest('div.checkbox')

    warn = $('<i id="spend_asap_warn" title="' + __('campaigns.form.spend_asap.warn') + '" class="fa fa-exclamation-circle">')
    warn.css({"color": "#c9302c"}).tooltip({html: true}).hide();
    parent.append(warn);

    if checkbox.is(':checked')
      warn.show();

    checkbox.on 'change', (e) =>
      if(e.target.checked)
        warn.show();
      else
        warn.hide();

  excludeDomainsHandlerInit: =>
    targetControl = $('#targeting_exclude_anonymous_domains')
    negativeTargetControl = $('#negative_targeting_exclude_anonymous_domains')

    handleCheckboxes = (first, second, section) =>
      first.on 'change', (e) =>
        el = e.target
        if(el.checked)
          second
            .prop('disabled', true)
            .attr('checked', false)
            .closest('label')
              .prop('title', __('campaigns.message.exclude_domains.error', {':label': $(el).closest('label').text().trim(), ':targeting': section}))
              .tooltip()
        else
          second
            .prop('disabled', false)
            .closest('label')
              .attr('title', null)
              .tooltip('destroy')

    handleCheckboxes(targetControl, negativeTargetControl, __('campaigns.form.campaign.section-targeting'))
    handleCheckboxes(negativeTargetControl, targetControl, __('campaigns.form.campaign.section-negative-targeting'))


  showModal: =>
    campaignId = @dynPriceBtn.attr('data-campaignId')
    advertiserId = @dynPriceBtn.attr('data-advertiserId')

    unless @modal
      @modal = $ INTENT.widgets.Campaigns.MODAL
      @modal.on 'shown.bs.modal', =>
        @loadDynamicPriceData(advertiserId, campaignId)
    @modal.modal()

  loadDynamicPriceData: (advertiserId, campaignId) =>
    table = @modal.find('#dynamic_price_data')
    $.ajax
      url: "/ajax/v2/campaigns/get_dynamic_prices"
      method: 'post'
      data:
        campaign_id: campaignId,
        advertiser_id: advertiserId
      beforeSend: =>
        Loader.show({target: "#dynamic_price_data-wrapper"})
      complete: =>
        Loader.hide({target: "#dynamic_price_data-wrapper"})
      success: (data) =>
        if data.data and data.data.length
          table.find('tbody').empty()
          for item in data.data
            tr = $('<tr>')
            for key in ['size', 'domain', 'device', 'os', 'browser', 'ssp']
              value = if item.features[key] then item.features[key] else ''
              tr.append($('<td><input readonly class="form-control" type="text" name="' + key + '[]" value="' + value + '"/></td>'));
            tr.append($('<td><input readonly class="form-control" type="text" name="price[]" value="' + item.price + '"/></td>'));

            #closeBtn = $('<i class="fa fa-remove remove_dynamic_price"></i>').on 'click', (e) =>
              #$(e.target).closest('tr').remove()
            #tr.append $('<td class="action"></td>').append closeBtn
            tr.append $('<td class="action"></td>')

            table.find('tbody').append(tr)



